import { render, staticRenderFns } from "./SynapEditorWrapper.vue?vue&type=template&id=e6aa9ae8"
import script from "./SynapEditorWrapper.ts?vue&type=script&lang=ts&external"
export * from "./SynapEditorWrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./SynapEditorWrapper.vue?vue&type=style&index=0&id=e6aa9ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports